export default __webpack_public_path__ + "static/media/Bedroom3.79c6b343.png";